import React from 'react';
import { ReactComponent as IconoOrigen } from './../imagenes/origen.svg';
import { ReactComponent as IconoDestino } from './../imagenes/destino.svg';
import { ReactComponent as IconoEstado } from '.././imagenes/estado.svg';

const Iconotipo = ({tipo}) => {

    switch(tipo){
        case 'Origen':
            return <IconoOrigen fill="green"/>;
        case 'Destino' :
            return <IconoDestino fill="orange"/>;
        
        default :
            return <IconoEstado/>;
    }
}
export default Iconotipo;